import type { OfferLocation } from '@dce-front/sdk-core';
import packageJson from '../../../package.json';
import { getPublicConfig } from '../config/config-helper';

export const getCustomUserAgent = (offerLocation: OfferLocation): string => {
  const { customUserAgent } = getPublicConfig();
  const polandPrefix = offerLocation === 'pl' ? ' poland -' : '';

  return $_BUILD_RENDERMODE_CSR
    ? 'myCANAL/CSR'
    : `${customUserAgent} -${polandPrefix} ${packageJson.version}`;
};
